import * as React from "react";
import Svg from "./StyledSvg";
type Props = {
  size?: "XS" | "S" | "M" | "L" | "XL" | "XXL";
  color?: string;
  style?: object;
};

interface SizeData {
    size: number;
    stroke: number;
  }

  interface AvailableSizes {
    XS: SizeData;
    S: SizeData;
    M: SizeData;
    L: SizeData;
    XL: SizeData;
    XXL: SizeData;
  }
  ;
const availableSizes: AvailableSizes = {"XS":{"size":16,"stroke":1.3},"S":{"size":20,"stroke":1.5},"M":{"size":24,"stroke":1.8},"L":{"size":40,"stroke":2.2},"XL":{"size":48,"stroke":2.5},"XXL":{"size":70,"stroke":2.8}};
function Cart({
  size = "M",
  color = "currentColor",
  style
}: Props): React.JSX.Element {
  const strokeWidth = availableSizes[size]?.stroke;
  const appliedSize = availableSizes[size]?.size;
  return <Svg width={appliedSize} height={appliedSize} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" color={color} style={style}><path vectorEffect="non-scaling-stroke" d="M8 17.5L5 3.5H3M8.25 17.5H18.25M8.25 17.5C7.78587 17.5 7.34075 17.6844 7.01256 18.0126C6.68437 18.3408 6.5 18.7859 6.5 19.25C6.5 19.7141 6.68437 20.1592 7.01256 20.4874C7.34075 20.8156 7.78587 21 8.25 21C8.71413 21 9.15925 20.8156 9.48744 20.4874C9.81563 20.1592 10 19.7141 10 19.25C10 18.7859 9.81563 18.3408 9.48744 18.0126C9.15925 17.6844 8.71413 17.5 8.25 17.5ZM18.25 17.5C17.7859 17.5 17.3408 17.6844 17.0126 18.0126C16.6844 18.3408 16.5 18.7859 16.5 19.25C16.5 19.7141 16.6844 20.1592 17.0126 20.4874C17.3408 20.8156 17.7859 21 18.25 21C18.7141 21 19.1592 20.8156 19.4874 20.4874C19.8156 20.1592 20 19.7141 20 19.25C20 18.7859 19.8156 18.3408 19.4874 18.0126C19.1592 17.6844 18.7141 17.5 18.25 17.5ZM5.64 6.5H19.99C20.54 6.49 20.99 6.94 20.99 7.49C20.99 7.57 20.97 7.66 20.95 7.74L19.35 13.74C19.23 14.17 18.83 14.48 18.38 14.48H7.33" stroke="currentColor" strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round" /></Svg>;
}
export default Cart;